import { gql } from '@apollo/client';

export const OVERVIEW_REPORT = gql`
  query OverviewReport($input: ReportInput!) {
    overviewReport(input: $input) {
      data {
        data {
          values
        }
        extraLabels
        extraLabels2
        extraLabels3
        keys
        labels
        points
        summary {
          extraString
          extraValue
          title
          value
        }
        title
        url
      }
      url
    }
  }
`;

export const TOP_SOLD_OVERVIEW_ITEMS_REPORT = gql`
  query TopSoldOverviewItemsReport($input: ReportInput!) {
    topSoldOverviewItemsReport(input: $input) {
      extraLabels
      extraLabels2
      extraLabels3
      keys
      labels
      points
      summary {
        extraString
        extraValue
        title
        value
      }
      title
      url
    }
  }
`;

export const CLUB_LOAD_BY_DAY = gql`
  query ClubLoadByDayOfWeekReport($input: ReportInput!) {
    clubLoadByDayOfWeekReport(input: $input) {
      data {
        values
      }
    }
  }
`;

export const OVERVIEW_EXPORT = gql`
  query exportOverviewReport($input: OverviewExportInput!) {
    exportOverviewReport(input: $input)
  }
`;
